<div [class.isPrinting]="printService.isPrinting">
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="medium"
               color="#000000"
               type="ball-spin-clockwise">
  </ngx-spinner>

  <div class="row margin-right-0px" *ngIf="BillsList">
    

      <div class="col-md-12 margin-top-10">
        <div class="card">
          <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
            <div class="row">
              <div class="col-md-6">
                <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Services Planned (Ordering)</label>
              </div>
              <!--<div class="col-md-7 text-align-right padding-left-0px padding-right-0px">
            <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Order"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Order</a>
          </div>-->
            </div>
          </div>
          <div class="card-body padding-all-0px">

            <div class="row">
              <div class="col-md-12">

                <ul class="nav nav-tabs nav-tab-service2 padding-left-15px" id="tabContent">
                  <li class="active margin-right-15px"><a class="nav-itemerp active" href="#NewOrder" data-toggle="tab">New Order</a></li>
                  <li class="margin-right-15px"><a class="nav-itemerp" href="#SerivcesHistory" data-toggle="tab">Serivces History</a></li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="NewOrder">
                    <div class="row my-profile-form">
                      <div class="columninvoice padding-left-15px">
                        <div class="card">
                          <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px margin-left-0px">
                            <div class="row margin-left-0px  margin-top-5px margin-bottom-5px">                              
                              <div class="col-md-4">
                                <!--<div class="display-inline">
                                  <button type="button"
                                          (click)="AddCategory()"                                          
                                          class="btn btn-secondary  margin-right-5px font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3"
                                          title="Click Here to Change Treatment Category">
                                    <i class="fas fa-ellipsis-h"></i>
                                  </button>
                                </div>-->
                                <div class="display-inline">
                                  <button type="button"                                          
                                          (click)="GenerateBill()"
                                          class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px">
                                    Generate Bill
                                  </button>
                                </div>
                                <div class="display-inline">
                                  <button type="button"                                          
                                          (click)="GenerateLabOrder()"
                                          class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px">
                                    Generate Lab Order
                                  </button>
                                </div>
                              </div>
                              <div class="col-md-2 text-align-right">
                                <h4 class="margin-bottom-0px color-Assign font-weight-bold margin-top-5px">Total : {{Total}}</h4>
                              </div>
                            </div>
                            <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
                              <div class="row padding-top-3px margin-left-0px">
                                <div class="col-md-12 padding-left-0px">
                                  <div class="">
                                    <div class="overflow-x">
                                      <table class="table table-striped margin-left-15px"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>
                                            <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                              #
                                            </th>
                                            <th class="padding-top-4px padding-bottom-4px">
                                              Date
                                            </th>
                                            <th class="padding-top-4px padding-bottom-4px">
                                              Service Description
                                            </th>
                                            <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                              QTY
                                            </th>
                                            <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                              Price
                                            </th>
                                            <th class=" padding-right-0px padding-top-4px padding-bottom-4px">
                                              Provider
                                            </th>
                                            <th hidden class=" padding-right-0px padding-top-4px padding-bottom-4px">
                                              Treatment Category
                                            </th>
                                            <th class="">

                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr *ngFor="let l of CurrentOPOrdersController;let RowIndex = index">
                                            <td class="td-padding-tb">

                                              {{RowIndex+1}}
                                            </td>
                                            <td class="td-padding-tb">

                                              {{l.PlannedServiceDate | date:'dd-MMM-yyyy'}}
                                            </td>
                                            <td class=" td-padding-tb">
                                              <a data-toggle="tooltip" data-placement="bottom" title="UNBILLED" *ngIf="l.ItemStatus=='UNBILLED'">

                                                <i class="fas fa-circle color-Rejected  nav-link-hand font-size-10px">
                                                </i>
                                              </a>
                                              <a data-toggle="tooltip" data-placement="bottom" title="BILLED" *ngIf="l.ItemStatus=='BILLED'">

                                                <i class="fas fa-circle color-blue  nav-link-hand font-size-10px">
                                                </i>
                                              </a>
                                              <a data-toggle="tooltip" data-placement="bottom" title="PAID" *ngIf="l.ItemStatus=='PAID'">

                                                <i class="fas fa-rupee-sign color-green  nav-link-hand font-size-10px">
                                                </i>
                                              </a>
                                              {{l.Details}}
                                            </td>

                                            <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity}}</td>
                                            <td class="text-align-center td-padding-tb padding-right-0px">{{l.UnitPrice}}</td>
                                            <td class=" td-padding-tb padding-right-0px">{{l.ProviderName}}</td>
                                            <td hidden class=" td-padding-tb padding-right-0px">{{l.TreatmentCategory}}</td>

                                            <td>
                                              <div class="display-inline">
                                                <a                                                    
                                                   class="nav-link-hand education-navlink" tooltip="Edit">
                                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                                </a>
                                              </div>
                                              <div class="display-inline">
                                                <a                                                    
                                                   class="nav-link-hand font-size-14 color-Rejected" title="Remove">
                                                  <i class="far fa-trash-alt nav-link-hand"></i>
                                                </a>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="columnbp3 background-white ">
                        <div class="position-fixed-Activities4">
                          <div class="card">
                            <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px padding-t-6px padding-left-8px">
                              <div class="row">
                                <div class="col-md-12 font-size-12px">
                                  Services
                                </div> 
                              </div>
                              <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
                                <div class="col-md-12 padding-left-0px display-inherit padding-right-0px">
                                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

                                </div>
                              </div>
                            </div>
                            <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px">
                              <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                <div class="table-component actor-table">
                                  <div class="table-responsive padding-right-11px">
                                    <table class="table table-striped table2">
                                      <tbody>
                                        <tr *ngFor="let l of pdata">
                                          <td class="td-padding-2px">
                                            <div class="row margin-left-zero margin-right"
                                                 (click)="AddServices(l)">
                                              <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                                                <button type="button"
                                                        class="btn  btn-sm plus-button " id="FileUpload"
                                                        name="upload">
                                                  <i class="fas fa-plus font-size-11p"></i>
                                                </button>
                                              </div>
                                              <div class="col-md-10 margin-tb-auto padding-left-0px">
                                                <label class="margin-bottom-0px color3">{{l.ServiceName}}</label>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>                   

                    </div>

                  <div class="tab-pane" id="SerivcesHistory">



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>

    <!--<div class="row" *ngIf="Formedit">
    <div class="col-md-8 padding-left-0px">


      <div class="card">

        <div class="card-body padding-all-0px">
          <div *ngIf="FormData" class="margin-top-10">


            <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

              <div [id]="'accordion'+RowIndex">
                <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                  <div class="row">
                    <div class="col-md-3">
                      <h5 class="mb-0">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                          {{l.Title}}

                        </button>

                      </h5>
                    </div>
                    <div class="col-md-9">
                      <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                      <button type="button"
                              (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>
                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                     [attr.data-parent]="'#accordion'+RowIndex">
                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                    <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                      <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                        {{f.Title}}
                      </div>
                      <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                        <div *ngIf="f.isSubHeader">
                          <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                        </div>


                        <div *ngIf="f.isTextField">
                          <div class="row form-group">
                            <div class="col-md-3 padding-right-0px text-align-right">
                              <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                            </div>
                            <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                            </div>
                          </div>


                        </div>
                        <div *ngIf="f.isSubChild">
                          <div class="row form-group">
                            <div class="col-md-3 text-align-right">
                              <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                            </div>:
                            <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                            </div>
                          </div>
                        </div>


                        <div *ngIf="f.Remarks">
                          <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                        </div>
                        <div *ngIf="f.HasSeparator">
                          <div class="border-bottom-light"></div>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">

    </div>
  </div>-->
    <!--<div class="row">
    <div class="col-md-12">
      <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
    </div>

  </div>-->
